// biome-ignore lint/correctness/noUnusedImports: type-only imports from the public entry keep the inferred `authClient` type nameable in declaration emit (TS2883)
import type {
	AccessControl,
	AuthQueryAtom,
	InferSignUpEmailCtx,
	InferUserUpdateCtx,
	OrganizationPlugin,
	Role,
} from "better-auth/client";
import { inferAdditionalFields, organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

const client = createAuthClient({
	baseURL: process.env.PUBLIC_SERVER_URL,
	basePath: "/auth",
	fetchOptions: {
		credentials: "include",
	},
	plugins: [
		organizationClient(),
		inferAdditionalFields({
			user: {
				firstName: {
					type: "string",
				},
				lastName: {
					type: "string",
				},
				state: {
					type: "string",
				},
				initials: {
					type: "string",
					required: false,
				},
				language: {
					type: "string",
					required: false,
					input: false,
				},
			},
		}),
	],
});

export const authClient: typeof client = client;
